import React, { useMemo } from 'react'
import { DataProvider, useDataFormat, useDataChange } from 'Simple/Data.js'
import formatISO from 'date-fns/formatISO/index.js'

import View from './view.js'

let today = formatISO(new Date(), { representation: 'date' })

export default function Logic(props) {
  let has_insurance_payment_accounts = useDataFormat({
    context: 'patient',
    viewPath: props.viewPath,
    format: patient => patient.insurance_payment_accounts.length > 0,
  })
  let charge_templates = useDataFormat({
    context: 'charge_templates',
    viewPath: props.viewPath,
  })
  let claim = useMemo(
    () => ({
      payment_account: null,
      notes: '',
      due_date: today,
      // moving by default the charges to the invoice when the patient doesn't have any insurance subscription
      charges: has_insurance_payment_accounts
        ? charge_templates.filter(item => item.is_included_in_insurance_claim)
        : [],
    }),
    [] // eslint-disable-line
    // ignore charge_templates, has_insurance_payment_accounts
  )
  let invoice = useMemo(
    () => ({
      payment_account: null,
      notes: '',
      due_date: today,
      charges: has_insurance_payment_accounts
        ? charge_templates.filter(item => !item.is_included_in_insurance_claim)
        : charge_templates,
    }),
    [] // eslint-disable-line
    // ignore charge_templates, has_insurance_payment_accounts
  )
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return (
    <DataProvider
      context="claim"
      value={claim}
      onChange={onClaimChange}
      viewPath={props.viewPath}
    >
      <DataProvider
        context="invoice"
        value={invoice}
        onChange={onInvoiceChange}
        viewPath={props.viewPath}
      >
        <View {...props} />
      </DataProvider>
    </DataProvider>
  )

  function onClaimChange(value, fn) {
    change(next => {
      next.data.claim = value
    })
  }

  function onInvoiceChange(value, fn) {
    change(next => {
      next.data.invoice = value
    })
  }
}
